import { QuizQuestionProps } from "@/pages/quiz/context/types";
import ProgressBar from "@ramonak/react-progress-bar";
import { useEffect, useRef, useState } from "react";

import Slide2 from "@/assets/images/proggress/2.png";
import Slide4 from "@/assets/images/proggress/4.jpg";

const SLIDES_DELAY = 3;
const slides = [Slide2, Slide4];

const ProgressCalculationBanner = ({
  setQuestionAnswer,
}: QuizQuestionProps<boolean>) => {
  const [timerTicks, setTimerTicks] = useState(0);

  const timer = useRef<number | null>(null);

  useEffect(() => {
    // first opens page

    if (!timer.current) {
      // disable Next question button
      timer.current = window.setInterval(() => {
        setTimerTicks((t) => t + 1);
      }, 1000);
    }

    // cleanup
    return () => {
      if (timer.current) {
        window.clearInterval(timer.current);
        timer.current = null;
      }
    };
  }, []);

  useEffect(() => {
    // end of play
    if (timerTicks >= slides.length * SLIDES_DELAY) {
      // if (timerTicks >= 4) {

      setQuestionAnswer(true);
      if (timer.current) {
        window.clearInterval(timer.current);
        timer.current = null;
      }
    }
  }, [timerTicks]);

  let slideIdx = Math.min(
    Math.floor(timerTicks / SLIDES_DELAY),
    slides.length - 1
  );

  const slide = slides[slideIdx];

  const progressNumber = (timerTicks / SLIDES_DELAY / slides.length) * 100;

  return (
    <div className="flex flex-col justify-center">
      <p className="section-title" style={{ fontSize: 18 }}>
        SkinnyRx identifies and addresses the root causes of your metabolic
        issues...
      </p>
      <img
        className="transition-all mb-8	"
        src={slide}
        alt="Results calculation..."
      />
      <ProgressBar
        className="animate-pulse duration-300"
        completed={progressNumber}
        isLabelVisible={false}
      />
      <p className="section-title my-4 " style={{ fontSize: 18 }}>
        Calculating your results…
      </p>
    </div>
  );
};

export { ProgressCalculationBanner };
